import { Commit } from 'vuex'

import UiScreenType from '@/models/ui-screen-type'

import dayjs, { Dayjs } from '@/dayjs'

export enum UtilityGetters {
  CurrentDate = '[Utility] CurrentDate',
  UiScreenType = '[Utility] UiScreenType',
  IsRetina = '[Utility] IsRetina',
  IsMobileScreen = '[Utility] IsMobileScreen',
}

export enum UtilityActionTypes {
  RefreshAllPages = '[Utility] RefreshAllPages',
}

export enum UtilityMutationTypes {
  SetCurrentDate = '[Utility] SetCurrentDate',
  SetUiScreenType = '[Utility] SetUiScreenType',
  SetIsRetina = '[Utility] SetIsRetina',
  RefreshAllPages = '[Utility] RefreshAllPages',
}

export interface State {
  currentDate: Dayjs
  screenType: UiScreenType
  isRetina: boolean
}

const initialState: State = {
  currentDate: dayjs.utc(),
  screenType: UiScreenType.Desktop,
  isRetina: false,
}

export default {
  state: initialState,
  getters: {
    [UtilityGetters.CurrentDate](state: State): Dayjs {
      return state.currentDate
    },
    [UtilityGetters.UiScreenType](state: State): UiScreenType {
      return state.screenType
    },
    [UtilityGetters.IsRetina](state: State): boolean {
      return state.isRetina
    },
    [UtilityGetters.IsMobileScreen](state: State): boolean {
      return [UiScreenType.Mobile, UiScreenType.MobileLandscape].includes(
        state.screenType,
      )
    },
  },
  actions: {
    [UtilityActionTypes.RefreshAllPages]({
      commit,
      getters,
    }: {
      commit: Commit
      getters: any
    }) {
      const currentCustomerId = getters.getCurrentCustomer.id
      commit(UtilityMutationTypes.RefreshAllPages, currentCustomerId)
    },
  },
  mutations: {
    [UtilityMutationTypes.SetCurrentDate](
      state: State,
      currentDate: string | undefined,
    ) {
      state.currentDate = currentDate ? dayjs.utc(currentDate) : dayjs.utc()
    },
    [UtilityMutationTypes.SetUiScreenType](
      state: State,
      screenType: UiScreenType,
    ) {
      state.screenType = screenType
    },
    [UtilityMutationTypes.SetIsRetina](state: State, isRetina: boolean) {
      state.isRetina = isRetina
    },
    [UtilityMutationTypes.RefreshAllPages](
      state: State,
      currentCustomerId: number,
    ) {
      localStorage.setItem('refresh', `${currentCustomerId}`)
      localStorage.setItem('refresh', 'false')
    },
  },
}
